import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=c2f1f180&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackForm.vue?vue&type=style&index=0&id=c2f1f180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1f180",
  null
  
)

export default component.exports